import { useState, useCallback } from 'react';
import { nanoid } from 'nanoid';

function useRipples() {
    const [ripples, setRipples] = useState({});
    const removeRippleEffect = useCallback((key) => {
        const { [key]: removedRipple, ...restRipples } = ripples;
        setRipples({ ...restRipples });
    }, [ripples]);
    const addRippleEffect = useCallback(({ x, y, size }) => {
        const key = nanoid();
        const newRipple = {
            x,
            y,
            key,
            size,
        };
        setRipples({ ...ripples, [key]: newRipple });
    }, [ripples]);
    return { ripples, removeRippleEffect, addRippleEffect };
}

export { useRipples };
